import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment/moment'

import CardAlternate from 'src/ui/molecules/Card/Alternate'
import Button from 'src/ui/atoms/Button'
import ImportProject from './ImportProject'
import useProjectsApi from './useProjectsApi'

interface IProjectTypes {
  token: string
  nft: string
  vesting: string
  staking: string
}

const Projects = () => {
  const navigate = useNavigate()
  const [projects, setProjects] = useState<[]>([])
  const [count, setCount] = useState(0)
  const [offset, setOffset] = useState(0)
  const limit = 9
  const { getProjects } = useProjectsApi()

  const projectIcons: IProjectTypes = {
    token: 'dollar',
    nft: 'puzzle',
    vesting: 'smart-contract',
    staking: 'smart-contract',
  }

  const projectTypes: IProjectTypes = {
    token: 'Token',
    nft: 'NFT Collection',
    vesting: 'Vesting Contract',
    staking: 'Staking Contract',
  }

  const handleGetProjects = async () => {
    const res = await getProjects({
      offset,
      limit,
    })

    if (res) {
      setProjects(res?.rows)
      setCount(res?.count)
    }
  }

  const handlePrevious = () => {
    if (offset >= 0) {
      setOffset(offset - limit)
    }
  }
  const handleNext = () => {
    if (offset + limit < count) {
      setOffset(offset + limit)
    }
  }

  useEffect(() => {
    handleGetProjects()
  }, [offset])

  const cards = projects.map((project: any) => ({
    id: project.id,
    title: project.data.tokenName || project.data.nftCollectionName || project.data.contractName,
    data:
      project.projectType === 'token' || project.projectType === 'nft'
        ? [
            {
              type: 'Type',
              value: projectTypes[project.projectType as keyof IProjectTypes],
            },
            {
              type: 'Symbol',
              value:
                project.data.detailedTokenTicker ||
                project.data.tokenTicker ||
                project.data.tokenSymbol ||
                project.data.nftSymbol,
            },
            {
              type: 'Status',
              value: project.status,
            },
          ]
        : [
            {
              type: 'Type',
              value: projectTypes[project.projectType as keyof IProjectTypes],
            },
            {
              type: 'Status',
              value: project.status,
            },
          ],
    status: project.status,
    icon: projectIcons[project.projectType as keyof IProjectTypes],
    network: project.data.network,
    chain: project.data.chain,
    createdAt: moment(project.createdAt).format('DD MMM YYYY'),
  }))

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-end gap-4">
        <Button size="M" name="Start a new project" onClick={() => navigate('/dashboard')} />

        <ImportProject />
      </div>

      {cards.length ? (
        <div className="mb-6 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {cards.map((card, key) => (
            <CardAlternate {...card} key={key} />
          ))}
        </div>
      ) : (
        <div className="w-full rounded-md bg-white bg-opacity-10 px-4 py-8 text-center text-lg text-white">
          You don't have any projects
        </div>
      )}
      {count > limit && (
        <div className="flex justify-between">
          <Button
            name="Previous"
            type="text"
            disabled={offset === 0}
            onClick={handlePrevious}
            iconLeft="arrow-left"
          />
          <Button
            name="Next"
            type="text"
            disabled={offset + limit >= count}
            iconRight="arrow-right"
            onClick={handleNext}
          />
        </div>
      )}
    </div>
  )
}

export default Projects
